<template>
    <div
        v-if="isOpen && suggestions.length"
        class="autocomplete-suggestions d-block w-100"
    >
        <div
            v-for="suggestion in suggestions"
            :key="suggestion[keyValue]"
            class="autocomplete-suggestion"
            :class="{
                selected: hoverSuggestion[keyValue] === suggestion[keyValue]
            }"
            @mouseover="hoverSuggestion = suggestion"
            @mouseleave="hoverSuggestion = {}"
            @click="selectSuggestion(suggestion)"
        >
            {{ suggestion[keyTitle] }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Autocomplete',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        suggestions: {
            type: Array,
            required: true
        },
        keyValue: {
            type: String,
            required: true
        },
        keyTitle: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            hoverSuggestion: {}
        }
    },

    methods: {
        selectSuggestion(suggestion) {
            this.$emit('selectSuggestion', { ...suggestion })
        }
    }
}
</script>
